import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { track } from '@amplitude/analytics-browser';
import { navigateHeaderRemove } from '@tiendanube/nexo';
import nexo from 'App/nexoClient';
import { RenderByCountry } from 'commons/components';
import EmptyStateBrazil from './Brazil/EmptyStateBrazil';
import { useDashboardController } from './Brazil/HomePageNuvemPago/hooks/useDashboardController';
import EmptyStateMexico from './Mexico/components/EmptyStateMexico';
import EmptyStateArgentina from './Argentina';

function Landing(): JSX.Element {
  const { activate, openAboutPage } = useDashboardController();
  const { t } = useTranslation();

  useEffect(() => {
    navigateHeaderRemove(nexo);
    track('nuvem-pago-conversion-empty-state');
  }, []);

  return (
    <RenderByCountry
      MX={<EmptyStateMexico />}
      AR={<EmptyStateArgentina />}
      BR={
        <EmptyStateBrazil
          title={t('landing.message.title')}
          primaryActionLabel={t('landing.message.action')}
          onClickPrimary={activate}
          descriptionFirstParagraph={t('landing.message.description1')}
          descriptionSecondParagraph={t('landing.message.description2')}
          secondaryActionLabel={t('landing.message.about')}
          onClickSecondary={openAboutPage}
        />
      }
    />
  );
}

export default Landing;
